// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__zf6cD","tab":"Tabs_tab__2iz8w","tabActive":"Tabs_tabActive__1Jp4B"};